module.exports = __webpack_public_path__ + "static/media/pic3@2x.103b2138.png";